import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Doughnut, Bar, Line, Pie } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import { withRouter, Link } from 'react-router-dom';

import Spin from '../../../components/loading';
import * as dashbaordActions from '../../../redux/dashboard/actions';
import { formatter } from '../../../utils';
import '../dashboard.scss';
import styles from '../dashboard.scss';

class Dashboard extends Component {
  componentDidMount() {
    this.props.fetchAllCafeAdminDashbaordData();
  }

  renderHeaderCards() {
    let {
      averageOrderAmountPerReservation,
      cafeImpurityAmount,
      averageTotalPeoplePerReservation,
      currency
    } = this.props.cafeAdminDashboardData;

    return (
      <>
        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card">
              <div className="dashboard-card__body">
                <h6>{locales('titles.cafeImpurityAmount')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(cafeImpurityAmount)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('tables.toman')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--green">
              <div className="dashboard-card__body">
                <h6>{locales('titles.averageOrderAmountPerReservation')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(averageOrderAmountPerReservation)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('tables.toman')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--purple">
              <div className="dashboard-card__body">
                <h6>{locales('titles.averageTotalPeoplePerReservation')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(averageTotalPeoplePerReservation)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.person.unit')}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMainChart() {
    return (
      <div className="col d-flex">
        <div className="w-75">
          <Line
            data={{
              labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
              datasets: [
                {
                  cubicInterpolationMode: 'monotone',
                  fill: true,
                  label: 'از کل کاربران',
                  data: [12, 19, 3, 5, 2, 3],
                  backgroundColor: ['#541C70'],
                  borderColor: [
                    'red',
                    'blue',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                  ],
                  borderWidth: 1,
                  type: 'line',
                  options: {
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            beginAtZero: true
                          }
                        }
                      ]
                    }
                  }
                }
              ]
            }}
            options={{
              legend: { display: true },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true
                    }
                  }
                ]
              }
            }}
          />
        </div>
        <div className="text-center justify-content-around pb-3 d-flex flex-column  w-25">
          <div className="font-large font-weight-bold border-bottom">
            {locales('titles.progressStatistics')}
          </div>
          <div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.instagramProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-75" />
              </div>
            </div>
            <div className="p-3">
              <div className="col  d-flex justify-content-start">
                {locales('titles.twitterProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-50" />
              </div>
            </div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.applicationProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-25" />
              </div>
            </div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.telegramProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-75" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderOtherCharts() {
    let {
      totalCanceledReservations,
      totalCanceledReservationsInPercent,
      totalReservations,

      totalActivatedUsers,
      totalActivatedUsersInPercent,
      totalUsers,

      totalUsedCafeCapacitiesInPercent,

      averageRseePurePriceInPercent,

      totalActiveCafeChairs
    } = this.props.cafeAdminDashboardData;

    return (
      <div className="col d-flex justify-content-center">
        <div className="dashboard-width-container d-flex">
          <div className="w-100 mx-2 card">
            <div className="card-body">
              <div className="w-100 d-flex justify-content-center align-items-start border-bottom">
                <div className="w-50 border-left">
                  <Pie
                    data={{
                      labels: [locales('titles.cancelationPercentageFromClient')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [
                            totalCanceledReservationsInPercent,
                            100 - totalCanceledReservationsInPercent
                          ],
                          backgroundColor: ['red', '#DDD'],
                          borderColor: ['red', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales(
                              'titles.cancelationsCount'
                            )} : ${totalCanceledReservations} \n ${locales(
                              'titles.reservationsCount'
                            )} : ${totalReservations}`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          color: 'white',
                          font: { size: 18, family: 'Vazir' },
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />

                  <div className="p-3 text-center">
                    {locales('titles.reservationsCount')} : {totalReservations || 0}
                  </div>
                  <div className="p-3 text-center">
                    {locales('titles.cancelationsCount')} : {totalCanceledReservations || 0}
                  </div>
                </div>

                <div className="w-50">
                  <Pie
                    data={{
                      labels: [locales('titles.cafeCapacityUsagePercentage')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [totalUsedCafeCapacitiesInPercent, 100 - totalUsedCafeCapacitiesInPercent],
                          backgroundColor: ['orange', '#DDD'],
                          borderColor: ['orange', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) => locales('titles.cafeCapacityUsagePercentage')
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          font: { size: 18, family: 'Vazir' },
                          color: 'white',
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />

                  <div className="p-3 text-center">
                    {locales('titles.activeCafesChairCount')} : {totalActiveCafeChairs}
                  </div>
                </div>
              </div>

              <div className="w-100 d-flex justify-content-center align-items-start">
                <div className="w-50 border-left">
                  <Pie
                    data={{
                      labels: [locales('titles.activeUsers')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [totalActivatedUsersInPercent, 100 - totalActivatedUsersInPercent],
                          backgroundColor: ['blue', '#DDD'],
                          borderColor: ['blue', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales('titles.activeUsersCount')} : ${totalActivatedUsers}`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          color: 'white',
                          font: { size: 18, family: 'Vazir' },
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />
                  <div className="p-3 text-center">
                    {locales('titles.totalUsersCount')} : {totalUsers}
                  </div>
                  <div className="p-3 text-center">
                    {`${locales('titles.activeUsersCount')} : ${totalActivatedUsers}`}
                  </div>
                </div>

                <div className="w-50">
                  <Pie
                    data={{
                      labels: [locales('titles.RseePureWagesPercentage')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [averageRseePurePriceInPercent, 100 - averageRseePurePriceInPercent],
                          backgroundColor: ['green', '#DDD'],
                          borderColor: ['green', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales('titles.RseePureWagesPercentage')} : 30`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          color: 'white',
                          font: { size: 18, family: 'Vazir' },
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let {
      cafeAdminDashboardDataLoading,
      cafeAdminDashboardDataError,
      cafeAdminDashboardDataMessage,
      cafeAdminDashboardDataFailed
    } = this.props;

    return (
      <div className="col p-0 m-0">
        <Spin spinning={cafeAdminDashboardDataLoading}>
          {cafeAdminDashboardDataError && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}

          {cafeAdminDashboardDataFailed && (
            <div className="alert alert-danger">{cafeAdminDashboardDataMessage}</div>
          )}

          <div>{this.renderHeaderCards()}</div>

          <Link target="_blank" to="/dashboard/guide">
            <div className="m-4">
              <span>{locales('titles.dashboardGuide')}</span>{' '}
              <span className="font-weight-bold text-danger">{locales('titles.here')}</span>{' '}
              <span>{locales('titles.click')}</span>
            </div>
          </Link>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeAdminDashboardDataLoading: state.dashboardReducer.cafeAdminDashboardDataLoading,
    cafeAdminDashboardDataFailed: state.dashboardReducer.cafeAdminDashboardDataFailed,
    cafeAdminDashboardDataError: state.dashboardReducer.cafeAdminDashboardDataError,
    cafeAdminDashboardDataMessage: state.dashboardReducer.cafeAdminDashboardDataMessage,
    cafeAdminDashboardData: state.dashboardReducer.cafeAdminDashboardData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeAdminDashbaordData: () => dispatch(dashbaordActions.fetchAllCafeAdminDashbaordData())
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Dashboard)
);
